<template>
  <div class="filter">
    <search></search>
    <favorited-searches :collapsable="collapsable"></favorited-searches>
    <div v-for="filter in filters">
      <checkboxes :label="filter.label"
                  :items="filter.items"
                  :model="filter.model"
                  :prefix="filter.name"
                  :collapsable="collapsable"
                  :type="filter.filterDefinition.type"
                  @updated="value => filter.model = value"
      >
      </checkboxes>
    </div>

    <div v-show="false" class="export">
      <button><i class="material-icons">add</i> Import filter</button>
      <button @click="exportFilterVisible=true" v-show="!exportFilterVisible"><i
        class="material-icons">content_paste</i> Export filter
      </button>
      <div v-show="exportFilterVisible">
        <i class="material-icons clickable" @click="exportFilterVisible=false">close</i>
        <div class="exportable">{{ exportable }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Checkboxes from '@/components/Checkboxes'
  import Tokens from '@/components/Tokens'
  import Search from '@/components/Search'
  import { mapGetters } from 'vuex'
  import FavoritedSearches from '@/components/FavoritedSearches.vue'
  import FiltersCollection from '@/domain/FiltersCollection'

  export default {
    name: 'filters',
    props: {
      collapsable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        exportFilterVisible: false
      }
    },
    computed: {
      ...mapGetters({
        exportable: 'destiny/filters/toExportable'
      }),
      filtersCollection () {
        return new FiltersCollection(this.$store.state.destiny.filters)
      },
      filters () {
        return Object.values(this.filtersCollection.filters).filter(fa => fa.label)
      }
    },
    methods: {
      focusSearch () {
        // TODO: implement
      }
    },
    components: {
      FavoritedSearches,
      Checkboxes,
      Tokens,
      Search
    }
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  .filter {
    .searches {
      .remembered-search {
        > div {
          flex-grow: 1
        }
        transition: background 0.2s ease-in-out;
        display: flex;

        padding: .5rem;
        &.collapsable {
          cursor: pointer;
        }

        &:hover {
          background-color: lighten($background, 5%);
        }
      }
    }
    padding: 8px;
    .export {
      padding: 1rem 0;
      width: 100%;
      overflow: hidden;
      .exportable {
        font-family: monospace;
        white-space: pre;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// Filters.vue?df5535e2